import React, { useState, useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux'

import { getWhitelist } from '../../../../redux/actions'

import { Grid, Paper } from '@material-ui/core'

import { makeStyles, fade } from '@material-ui/core/styles'

import WhitelistList from './WhitelistList'

import { keyify2 } from '../../../../utils'

import TreeView from '@material-ui/lab/TreeView'
import UnitTree from '../../tools/UnitTree'

const useStyles = makeStyles((theme) => ({
  backBtn: {
    backgroundColor: '#8BB84B',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#588518'
    }
  },
  listContainer: {
    maxHeight: '32.5em',
    overflow: 'scroll'
  },
  whitelistCard: {
    width: '85%',
    margin: theme.spacing(2, 0)
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade('#868787', 0.15),
    '&:hover': {
      backgroundColor: fade('#868787', 0.25)
    },
    width: '75%',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  searchIcon: {
    padding: theme.spacing(0, 1),
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    padding: theme.spacing(2, 1, 2, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(5)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%'
  },
  container: {
    maxHeight: '16em',
    marginTop: '1em'
  },
  searchBtn: {
    color: '#fff',
    backgroundColor: '#3984f7',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  modal: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '50%',
    position: 'inline-grid !important'
  },
  siteInput: {
    width: '100%',
    textTransform: 'none'
  },
  encryptInput: {
    maxHeight: 'none',
    height: 'auto'
  },
  encryptSelect: {
    paddingTop: '0.5em',
    backgroundColor: '#3984f7',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    color: '#fff',
    fontWeight: 700,
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  encryptSelectFocus: {
    paddingLeft: theme.spacing(1),
    '&:focus': {
      backgroundColor: '#0651C4',
      borderTopLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit'
    }
  },
  encryptForm: {
    height: 'auto',
    font: 'inherit',
    color: 'currentColor',
    width: '100%',
    display: 'block',
    padding: theme.spacing(1, 1)
  },
  descriptionInput: {
    width: '100%'
  },
  siteDescription: {
    textTransform: 'none'
  },
  deleteBtn: {
    backgroundColor: theme.palette.action.active,
    margin: 'auto',
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.error.light
    }
  },
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    }
  },
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  contentGridHide: {
    maxHeight: '0px',
    transition: '0.5s',
    overflow: 'hidden',
    padding: '0 !important'
  },
  contentGridShow: {},
  siteModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '1050 !important'
  },
  modalContainer: {
    boxShadow: theme.shadows[5],
    // border: '2px solid #000',
    width: '30em'
  },
  siteInfoContainer: {
    padding: theme.spacing(2, 2)
  },
  whitelistAppbar: {
    backgroundColor: '#3984f7',
    color: '#fff'
  },
  whitelistContainer: {
    height: 'auto'
  },
  toggles: {
    fontSize: '1.2em'
  },
  errorButton: {
    textTransform: 'none',
    fontWeight: '600',
    backgroundColor: '#f0ad4e',
    color: '#fff',
    paddingLeft: '0.5em',
    paddingRight: '0.5em',
    '&:hover': {
      backgroundColor: '#BD7A1B',
      color: '#fff'
    }
  }
}))

/**
 * Returns whitelist settings forms
 */
const Whitelist = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const TreeData = useSelector(state => state.auth.unitTree)
  const unitWhitelist = useSelector(state => state.whitelist.whitelist)

  const [selectedKeys, setSelectedKeys] = useState(keyify2(TreeData))
  const [selectedKey, setSelectedKey] = useState(TreeData[0].key)

  const [whitelistsInfo, setWhitelistInfo] = useState({})
  const [whitelistItems, setWhitelistItems] = useState([])

  useEffect(() => {
    if (Object.keys(unitWhitelist).length === 0) {
      dispatch(getWhitelist(selectedKey))
    } else {
      if (unitWhitelist.unitName && unitWhitelist.unitID) {
        const { unitName, unitID, whitelist } = unitWhitelist

        if (unitID !== selectedKey) {
          dispatch(getWhitelist(selectedKey))
        } else {
          setWhitelistInfo({ unitName, unitID })
          setWhitelistItems(whitelist)
        }
      }
    }
  }, [unitWhitelist, dispatch, selectedKey])

  const handleNodeSelect = async (keySelected) => {
    if (keySelected !== selectedKey) {
      setSelectedKey(keySelected)
    }
  }

  const handleNodeAugment = async (key, children, isExpanded) => {
    if (isExpanded) {
      const tempSelected = [...selectedKeys]
      const keysToRemove = [key, ...keyify2(children)]

      const newSelected = tempSelected.filter((selectedKey) => keysToRemove.findIndex((removeKey) => removeKey === selectedKey) === -1)

      setSelectedKeys(newSelected)
    } else {
      const tempSelected = [...selectedKeys]
      const keysToAdd = [key, ...keyify2(children)]
      const addedKeys = []

      keysToAdd.forEach((addKey) => {
        if (tempSelected.findIndex((selectedKey) => selectedKey === addKey) === -1) {
          addedKeys.push(addKey)
        }
      })

      setSelectedKeys([...selectedKeys, ...addedKeys])
    }
  }

  return (
    <>
      <Grid container direction='row'>
        <Grid item container direction='column' spacing={2} className='mx-auto my-auto'>

          <Grid container item direction='row'>
            <h2 className=''>Whitelist Manager</h2>
          </Grid>

          <Grid container item direction='row' spacing={2} className='mx-auto'>
            <Grid item xs={4}>
              <Paper elevation={2} className='w-100 p-3'>
                <TreeView expanded={selectedKeys} className={useStyles().unitTree} disableSelection>
                  <UnitTree
                    onNodeSelect={handleNodeSelect}
                    selectedKeys={[selectedKey]}
                    treeData={TreeData}
                    expandedKeys={selectedKeys}
                    onNodeAugment={handleNodeAugment}
                  />
                </TreeView>
              </Paper>

            </Grid>

            <Grid item xs={8}>
              <WhitelistList
                classes={classes}
                whitelistsInfo={whitelistsInfo}
                whitelistItems={whitelistItems}
                unitID={selectedKey}
              />
            </Grid>
          </Grid>

        </Grid>
      </Grid>
    </>
  )
}

export default Whitelist
